module.exports = __webpack_public_path__ + "img/Glowkit-AddState.532e398c.jpg";